// Legacy export format because this is used by some build-time scripts stuck in the past.
// eslint-disable-next-line import/no-commonjs
module.exports = {
    APP_NAME: 'Momentum',
    FEEDBACK_URL: 'https://scratch.mit.edu/users/kokofixcomputers#comments',
    GITHUB_URL: 'https://github.com/Momentum-Scratch'
};
